import { createContext, useContext, type ReactNode } from 'react';

export type TiptapFileSrcResolver = (fileDrn: unknown, legacyUrl: string) => string;

export const identityTiptapFileSrcResolver: TiptapFileSrcResolver = (_fileDrn, legacyUrl) =>
  legacyUrl;

const TiptapFileSrcContext = createContext<TiptapFileSrcResolver>(identityTiptapFileSrcResolver);

export function TiptapFileSrcProvider({
  resolver,
  children,
}: {
  resolver: TiptapFileSrcResolver;
  children: ReactNode;
}) {
  return <TiptapFileSrcContext.Provider value={resolver}>{children}</TiptapFileSrcContext.Provider>;
}

export function useTiptapFileSrcResolverFromContext(): TiptapFileSrcResolver {
  return useContext(TiptapFileSrcContext);
}

export function useTiptapFileSrc(fileDrn: unknown, legacyUrl: string): string {
  const resolver = useContext(TiptapFileSrcContext);
  return resolver(fileDrn, legacyUrl);
}
